// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "vendors" + "-" + "d440195e057655bc43f3" + ".js";
};